import PropTypes from 'prop-types';
import React from 'react';
import Growl from './Growl.jsx';
import { instance as growler } from './Growler.js';
import styles from './GrowlArea.styles.js';
import growlStyles, {
  closeAnimationSecondsAutomatic,
  closeAnimationSecondsForced,
  openAnimationSeconds,
} from './Growl.styles.js';

class GrowlArea extends React.Component
{
  constructor(props) {
    super(props);
    this.state = {
      growls: [],
    };
  }

  addGrowl(growl) {
    let growls = this.state.growls.slice();
    growls.push(growl);

    this.setState({ growls: growls });
  }

  addGrowlWithAnimation(growl, seconds) {
    growl.style = growlStyles.openAnimation.calculate(seconds);

    this.addGrowl(growl);

    setTimeout(() => {
      this.updateGrowl(growl.id, x => delete x.style);
    }, seconds * 1000);
  }
  
  addGrowlsWithAnimation(growls, seconds) {
    growls.forEach(growl => {
      growl.style = growlStyles.openAnimation.calculate(seconds);
    });
    
    let mergedGrowls = [ ...this.state.growls, ...growls];
    
    this.setState({ growls: mergedGrowls });

    growls.forEach(g => {
      setTimeout(() => {
        this.updateGrowl(g.id, x => delete x.style);
      }, seconds * 1000);
    });
  }

  componentDidMount() {
    growler.onGrowl(x => {
      if (Array.isArray(x)) {
        this.addGrowlsWithAnimation(x, openAnimationSeconds);
      } else {
        if (x.suppressOpenAnimation) {
          this.addGrowl(x);
        } else {
          this.addGrowlWithAnimation(x, openAnimationSeconds);
        }
      }
    });
  }

  removeGrowl(id) {
    let growl = this.state.growls.find(x => x.id === id);

    if (!growl) {
      return;
    }

    let growls = this.state.growls
      .filter(x => x !== growl);

    if (growl.onClose) {
      growl.onClose();
    }

    this.setState({ growls: growls });
  }

  removeGrowlWithAnimation(id, seconds) {
    this.updateGrowl(id, x => x.style = growlStyles.closeAnimation.calculate(seconds));

    setTimeout(() => {
      this.updateGrowl(id, x => delete x.style);
      this.removeGrowl(id);
    }, seconds * 1000);
  }

  updateGrowl(id, update) {
    let growl = this.state.growls
      .find(x => x.id === id);
    growl = Object.assign({}, growl);
    update(growl);

    let growls = this.state.growls
      .map(x => x.id === id ? growl : x);

    this.setState({ growls: growls });
  }

  render() {
    let {
      verticalBoundary,
      boxStyle,
      ...rest
    } = this.props;
    let {
      growls,
    } = this.state;

    if (verticalBoundary === 'bottom') {
      growls = growls.slice().reverse();
    }

    return (
      <div style={styles.container.calculate({
        verticalBoundary: verticalBoundary,
      })} {...rest}>
        {growls.map(({ id, onClose, ...growlProps }) => (
          <Growl
            {...growlProps}
            close={(opts) => this.handleGrowlClose(id, opts)}
            key={id}
            boxStyle={boxStyle}
          >
          </Growl>
        ))}
      </div>
    );
  }

  handleGrowlClose(id, { wasUserInitiated }={}) {
    let seconds = wasUserInitiated ? closeAnimationSecondsForced : closeAnimationSecondsAutomatic;
    this.removeGrowlWithAnimation(id, seconds);
  }
}

GrowlArea.propTypes = {
  verticalBoundary: PropTypes.oneOf(['bottom', 'top']),
  boxStyle: PropTypes.object
};

GrowlArea.defaultProps = {
  verticalBoundary: 'bottom',
  boxStyle: {}
};

export default GrowlArea;
